export default {
  /**
   * Gets the active store index.
   *
   * @public
   * @param {Array} state
   * @returns {Number} activeStoreIndex
   */
  activeStoreIndex: (state) => {
    return state.activeStoreIndex
  }
}
